// src/Section/Home/Terravia.jsx

import React from "react";
import Banner from "../../Section/Home/Banner/banner.jsx";
import Desktop from "../../Media/Header/Desktop/Desktop_Vireya.webp";
import Mobile from "../../Media/Header/Mobile/Mobile_Vireya.webp";
import About from "../../Section/Detail/about/about.jsx";
import Promo from "../../Section/Home/Promo/promo.jsx";
import Lokasi from "../../Section/Home/Lokasi/lokasi.jsx";
import Terraviadata from "./Vireya.json";
import promoData from "./promo.json";
import logo from "../../Media/RumahLogo/Vireyalogo.png";
import hardsell from "../../Media/Promo/Hardsell_Vireya.webp";
import Produk from "../../Pages/Vireya/Vireya/Vireya1.jsx";

import Surrounding from "../../Section/Home/surrounding/Surrounding.jsx";

const Terravia = () => {
  return (
    <div>
      <Banner Desktop={Desktop} Mobile={Mobile} />
      <About
        logo={logo}
        judul={Terraviadata.judul}
        Deskripsi={Terraviadata.deskripsi}
      />
      <Promo
        image={hardsell}
        title={promoData.title}
        points={promoData.points}
        whatsapp={promoData.whatsapp}
      />
      <Produk />

      <Surrounding />

      <Lokasi />
    </div>
  );
};

export default Terravia;
